import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { GenericService } from "src/app/services/generic/generic.service";
import { SelectItem } from "primeng/api";
@Component({
  selector: "app-generic-dropdown",
  templateUrl: "./generic-dropdown.component.html",
  styleUrls: ["./generic-dropdown.component.css"],
})
export class GenericDropdownComponent implements OnInit, OnChanges {
  @Input() database: string = "";
  @Input() item: string = "";
  @Input() ordenado: boolean = true;
  @Input() where: string = "";
  @Input() optionsLabels: string[] = [];
  @Input() separator: string = " - ";

  // @Input() orderby: string = 'nombre';
  public orderby: string = "nombre";
  //public where:string = '';

  @Output() selectItem: EventEmitter<string> = new EventEmitter<string>();
  @Output() selectNameItem: EventEmitter<any> = new EventEmitter<string>();

  public genericos: SelectItem[] = [{ label: "Seleccione", value: null }];

  public hiddenSelect = false;

  constructor(private genericService: GenericService) {}

  ngOnInit() {
    this.reloadData();
  }

  reloadData() {
    this.genericos = [];
    let iguales = this.where.split("=");
    this.where =
      iguales.length > 0 ? (iguales[1] == " " ? "" : this.where) : "";

    if (!this.ordenado) {
      this.orderby = null;
    }

    this.genericService
      .getListSimple(this.database, this.orderby, this.where)
      .toPromise()
      .then((data: any) => {
        for (let index = 0; index < data.productos.length; index++) {
          let name = "";

          let aux = {}

          if (this.optionsLabels.length > 0) {
            for (let i = 0; i < this.optionsLabels.length; i++) {
              const key = this.optionsLabels[i];

              aux[key] = data.productos[index][key];

              name += data.productos[index][key];
              if (i < this.optionsLabels.length - 1) {
                name += this.separator;
              }
            }
          } else {
            name = data.productos[index].nombre;
          }

          this.genericos.push({
            label: name,
            value: data.productos[index].id
          });
        }
      })
      .then(() => {
        // this.item = this.item;
        this.hiddenSelect = true;
      })
      .catch((error) => {
        console.log("Error", error);
      });
  }

  sendCategoria() {
    const itemSelected = this.genericos.filter((it) => it.value == this.item);
    this.selectItem.emit(this.item);

    if(this.optionsLabels.length > 0){
      console.log(itemSelected[0]);
      
      this.selectNameItem.emit(itemSelected[0]);
    } else {
      this.selectNameItem.emit(itemSelected[0].label);
    }

  }

  ngOnChanges(changes: SimpleChanges): void {}
}
